import React from 'react';
import {
  Stack,
  HStack,
  VStack,
  Box,
  Text,
  Divider,
  Image,
} from '@chakra-ui/react';
import icon1 from '../img/header/1.png';
import icon2 from '../img/header/2.png';
import icon3 from '../img/header/3.png';
import icon4 from '../img/header/4.png';
import icon5 from '../img/header/5.png';
import icon6 from '../img/header/6.png';
import num1 from '../img/header/101.png';
import num2 from '../img/header/102.png';
import num3 from '../img/header/103.png';
const Header = () => {
  return (
    <>
      <VStack align="stretch" p={['5px','10px']} m={['20px','50px']} >
        <Box color="#92B9B4" mt={'20px'}>
          <Text fontSize="5xl" fontWeight="bold">
            {' '}
            مُنطَلق مُبَادرة تَرجِم{' '}
          </Text>
          <Divider width={'25px'} border={'6px solid '} borderColor="#102836" />
        </Box>

        <Box>
          <Text fontSize="xl" mt={'2px'}>
            للمملكة العربية السعودية مكانةً مرموقة في العالم، فهي قلب العالم
            العربي ومحور ربط القارات الثلاث، ومن هذا المنطلق ومن منظور تطلعات
            رؤية المملكة واستراتيجيتها الوطنية للثقافة تأتي أهمية مبادرة وطنية
            تعني بإثراء المحتوى العربي والمعرفي من خلال الترجمة من اللغة العربية
            وإليها، وتساهم في تعزيز التبادل الثقافي والمعرفي في العالم
          </Text>
        </Box>

        <Box>
          <HStack spacing="24px" mt={'10px'} color={'#102836'}>
            <Box textAlign={'center'}>
              <Image src={icon1} overflow={'hidden'} />
              <Text fontSize="3xl" fontWeight={'bold'}>
                مجتمع حيوي{' '}
              </Text>
            </Box>
            <Box textAlign={'center'}>
              <Image src={icon3} />
              <Text fontSize="3xl" fontWeight={'bold'}>
                اقتصاد مزدهر{' '}
              </Text>
            </Box>
            <Box textAlign={'center'}>
              <Image src={icon2} />
              <Text fontSize="3xl" fontWeight={'bold'}>
                وطن طموح
              </Text>
            </Box>
          </HStack>
        </Box>
        {/* الاستراتيجية الوطنية للثقافة  */}
        <Box color="#92B9B4" mt={'60px !important'}>
          <Text fontSize="5xl" fontWeight="bold">
            {' '}
            الاستراتيجية الوطنية للثقافة{' '}
          </Text>
          <Divider width={'25px'} border={'6px solid '} borderColor="#102836" />
        </Box>
        <Box>
          <HStack spacing="24px" mt={'10px'} color={'#102836'}>
            {/* 1 */}
            <HStack spacing="1px">
              <Box>
                <Image src={icon4} w={[120]} h={[120]} />
              </Box>
              <Box>
                <Text fontSize="1xl" fontWeight={'bold'}>
                  الثقافة
                  <br />
                  كنمط حياة
                </Text>
              </Box>
            </HStack>
            {/* 2 */}
            <HStack spacing="1px">
              <Box>
                <Image src={icon5} w={[120]} h={[120]} />
              </Box>
              <Box>
                <Text fontSize="1xl" fontWeight={'bold'}>
                  {' '}
                  الثقافة من أجل <br />
                  النمو الاقتصادي
                </Text>
              </Box>
            </HStack>
            {/* 3 */}
            <HStack spacing="1px">
              <Box>
                <Image src={icon6} w={[120]} h={[120]} />
              </Box>
              <Box>
                <Text fontSize="1xl" fontWeight={'bold'}>
                  الثقافة من أجل
                  <br />
                  تعزيز مكانة المملكة
                  <br />
                  الدولية
                </Text>
              </Box>
            </HStack>
          </HStack>
        </Box>
        {/* الاهداف */}
        <Box color="#92B9B4" mt={'60px !important'}>
          <Text fontSize="5xl" fontWeight="bold">
            أهداف مبادرة ترجم
          </Text>
          <Divider width={'25px'} border={'6px solid '} borderColor="#102836" />
        </Box>
        <VStack spacing={0} align="stretch">
          {/* 1 */}
          <Box>
            <HStack spacing="10px">
              <Box>
                <Image src={num1} w={120} h={100} />
              </Box>
              <Box>
                <Text fontSize="xl" mt={'2px'}>
                  تجسير الهوة المعرفية بين العالم العربي والعالم عن طريق الترجمة
                  المنتقاة كماً وكيفاً بنا يثري ثقافة المجتمع ويحقق لأفراده
                  متطلبات التطور والنمو والتعلم
                </Text>
              </Box>
            </HStack>
          </Box>
          {/* 2 */}
          <Box>
            <HStack spacing="10px">
              <Box>
                <Image src={num2} w={120} h={100} />
              </Box>
              <Box>
                <Text fontSize="xl" mt={'2px'}>
                  إتاحة محتوى معرفي متجدد عن طريق الترجمة يعمل كمحرك للنمو
                  الاقتصادي وممكن لاقتصاد المعرفة وموطن للتقنيات الحديثة ومعزز
                  للتبادل التجاري
                </Text>
              </Box>
            </HStack>
          </Box>
          {/* 3 */}
          <Box>
            <HStack spacing="10px">
              <Box>
                <Image src={num3} w={120} h={100} />
              </Box>
              <Box>
                <Text fontSize="xl" mt={'2px'}>
                  ترسيخ مكانة المملكة في العالم العربي كقائد لجهود خدمة الثقافة
                  العربية وفي العالم أجمع كبوابة للتبادل المعرفي والثقافي
                  والحضاري بينه وبين العالم العربي
                </Text>
              </Box>
            </HStack>
          </Box>
        </VStack>
      </VStack>
    </>
  );
};

export default Header;
